import { render, staticRenderFns } from "./ThumbnailDropzone2.vue?vue&type=template&id=01b5cdfa&scoped=true&"
import script from "./ThumbnailDropzone2.vue?vue&type=script&lang=js&"
export * from "./ThumbnailDropzone2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b5cdfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b5cdfa')) {
      api.createRecord('01b5cdfa', component.options)
    } else {
      api.reload('01b5cdfa', component.options)
    }
    module.hot.accept("./ThumbnailDropzone2.vue?vue&type=template&id=01b5cdfa&scoped=true&", function () {
      api.rerender('01b5cdfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/components/cards/form/ThumbnailDropzone2.vue"
export default component.exports